function isAddressValid(location) {
  var city = location.city;
  return !!city;
}
export default isAddressValid;
//# sourceMappingURL=isAddressValid.js.map